import { render, staticRenderFns } from "./SOReport.vue?vue&type=template&id=e51288a2&scoped=true&"
import script from "./SOReport.vue?vue&type=script&lang=js&"
export * from "./SOReport.vue?vue&type=script&lang=js&"
import style0 from "./SOReport.vue?vue&type=style&index=0&id=e51288a2&scoped=true&lang=css&"
import style1 from "./SOReport.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51288a2",
  null
  
)

export default component.exports